// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const magmar: PokeData = {
  "id": 126,
  "name": "magmar",
  "height": 13,
  "weight": 445,
  "base_experience": 173,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "fire-punch",
    "tackle",
    "leer",
    "ember",
    "flamethrower",
    "hyper-beam",
    "low-kick",
    "fire-spin",
    "smokescreen",
    "confuse-ray",
    "smog",
    "fire-blast",
    "poison-gas",
    "flame-wheel",
    "scary-face",
    "feint-attack",
    "sunny-day",
    "lava-plume",
    "flame-burst",
    "clear-smog"
  ],
  "moves": [
    "fire-punch",
    "tackle",
    "leer",
    "ember",
    "flamethrower",
    "fire-spin",
    "confuse-ray",
    "poison-gas",
    "scary-face",
    "sunny-day",
    "magma-storm",
    "eruption",
    "fire-ball"
  ],
  "evolution_chain": {
    "id": 61,
    "item": null,
    "species": [
      {
        "name": "magby",
        "order": 148,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "magmar",
        "order": 149,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 240,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "magmortar",
        "order": 150,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 126,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68,
    "speed": 93,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
